//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { AddPersonWidgetRequest } from './models/AddPersonWidgetRequest';
import type { MyWidgetDetailsResponse } from './models/MyWidgetDetailsResponse';
import { Utilities } from './Utilities';
import { WidgetType } from './models/WidgetType';

export class WidgetsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        addPersonWidget: (): string => {
            let clientRequestUrl = '/api/v3/widgets/person-widgets/me';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        deletePersonWidget: (
			widgetType: WidgetType,
        ): string => {
            let clientRequestUrl = '/api/v3/widgets/person-widgets/me?';

            if (widgetType === undefined || widgetType === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefinedAndNotNull('widgetType'));
            } else {
                clientRequestUrl += `widgetType=${encodeURIComponent(String(widgetType))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        autoSubscribe: (): string => {
            let clientRequestUrl = '/api/v3/widgets/do-auto-subscribe/me';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getMyWidgetDetails: (): string => {
            let clientRequestUrl = '/api/v3/widgets/widget-details/me';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Add a person widget
     * @return Created
     */
    async addPersonWidget(
        body: AddPersonWidgetRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.addPersonWidget();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Delete a person Widget
     * @return No Content
     */
    async deletePersonWidget(
        widgetType: WidgetType,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.deletePersonWidget(
            widgetType,
        );

        const options = {
            method: 'DELETE',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Auto add widgets to a user depending on user access
     * @return Created
     */
    async autoSubscribe(): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.autoSubscribe();

        const options = {
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Get widget details for the connected user
     * @return OK
     */
    async getMyWidgetDetails(): Promise<MyWidgetDetailsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getMyWidgetDetails();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<MyWidgetDetailsResponse>(_response, false, []);
    }
}
